import { useState, useEffect } from "react";

var useSliderIndex = function (sliderRef) {
  var _state = useState(0);
  var activeIndex = _state[0];
  var setActiveIndex = _state[1];

  useEffect(function () {
    var el = sliderRef.current;
    if (!el) return;

    var findActiveIndex = function () {
      var items = el.querySelectorAll(".uk-slider-items > *");
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains("uk-active")) {
          return i;
        }
      }
      return -1;
    };

    var update = function () {
      var idx = findActiveIndex();
      if (idx >= 0) setActiveIndex(idx);
    };

    var observer = new MutationObserver(update);
    observer.observe(el, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    el.addEventListener("itemshow", update);
    el.addEventListener("itemshown", update);

    update();
    var checkInit = setInterval(function () {
      if (findActiveIndex() >= 0) {
        update();
        clearInterval(checkInit);
      }
    }, 200);

    return function () {
      observer.disconnect();
      el.removeEventListener("itemshow", update);
      el.removeEventListener("itemshown", update);
      clearInterval(checkInit);
    };
  }, [sliderRef]);

  return activeIndex;
};

export default useSliderIndex;
